import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import logoLanding from "@/assets/logo.svg";

export const LandingHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 h-20 z-50">
      {/* Glassmorphism backdrop */}
      <div className="absolute inset-0 bg-white/70 backdrop-blur-xl border-b border-[#D8DEE9]/30"></div>

      <div className="relative h-full max-w-7xl mx-auto pl-4 pr-2 sm:pl-6 sm:pr-3 md:px-12 lg:px-16 flex items-center">
        <img src={logoLanding} alt="KopfAI" width="198" height="40" className="w-auto h-9 md:w-auto md:h-10" />
        <div className="flex-1"></div>
        <div className="flex items-center gap-2 md:gap-8">
          <nav className="hidden md:flex gap-8" aria-label="Navegação principal">
            <a
              href="#about"
              className="text-sm text-[#272D37] hover:text-[#4A4E69] transition-all duration-300 font-medium relative group"
              aria-label="Saiba mais sobre a KopfAI"
            >
              Sobre a KopfAI
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
            </a>
            <a
              href="https://blog.kopfai.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#272D37] hover:text-[#4A4E69] transition-all duration-300 font-medium relative group"
            >
              Blog
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#FFD166] group-hover:w-full transition-all duration-300"></span>
            </a>
          </nav>
          <Link to="/auth">
            <Button
              className="h-9 px-4 md:h-10 md:px-6 rounded-full bg-[#4A4E69] text-white hover:bg-[#4A4E69]/90 text-xs md:text-sm font-bold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 border border-[#4A4E69]/20"
              style={{
                boxShadow: "0 10px 25px rgba(74, 78, 105, 0.15)",
              }}
            >
              <span className="md:hidden">Login</span>
              <span className="hidden md:inline">Fazer login</span>
            </Button>
          </Link>
          <button
            className="md:hidden text-[#272D37] p-2 hover:bg-[#D8DEE9]/30 rounded-lg transition-all duration-300"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Menu Mobile - Lateral Direita */}
      {isMenuOpen && (
        <>
          <div
            className="fixed inset-0 bg-[#4A4E69]/20 backdrop-blur-sm md:hidden z-40 animate-in fade-in duration-200"
            onClick={() => setIsMenuOpen(false)}
          />
          <div
            className="fixed top-0 right-0 h-full w-64 bg-white/90 backdrop-blur-2xl border-l border-[#D8DEE9]/50 shadow-2xl md:hidden z-50 animate-in slide-in-from-right duration-300"
            style={{
              boxShadow: "-10px 0 40px rgba(74, 78, 105, 0.1)",
            }}
          >
            <div className="p-6 flex flex-col gap-6">
              <button
                className="self-end text-[#272D37] p-2 hover:bg-[#D8DEE9]/30 rounded-lg transition-all duration-300"
                onClick={() => setIsMenuOpen(false)}
                aria-label="Fechar menu"
              >
                <X size={24} />
              </button>
              <nav className="flex flex-col gap-4">
                <a
                  href="#about"
                  className="text-sm text-[#272D37] hover:text-[#4A4E69] hover:bg-[#D8DEE9]/20 transition-all duration-300 py-3 px-4 rounded-lg font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sobre a KopfAI
                </a>
                <a
                  href="https://blog.kopfai.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[#272D37] hover:text-[#4A4E69] hover:bg-[#D8DEE9]/20 transition-all duration-300 py-3 px-4 rounded-lg font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Blog
                </a>
                <Link to="/auth" onClick={() => setIsMenuOpen(false)}>
                  <Button
                    className="w-full mt-4 h-10 rounded-full bg-[#4A4E69] text-white hover:bg-[#4A4E69]/90 text-sm font-bold shadow-lg hover:shadow-xl transition-all duration-300"
                    style={{
                      boxShadow: "0 10px 25px rgba(74, 78, 105, 0.15)",
                    }}
                  >
                    Fazer Login
                  </Button>
                </Link>
              </nav>
            </div>
          </div>
        </>
      )}
    </header>
  );
};
